/**
 * 調査ステッパーの画面名リスト
 */
export const inspectionStepNameList = [
  '調査員情報',
  '建築物概要',
  '調査ステップ1',
  '調査ステップ2',
  '判定結果'
]
